import { Component, EventEmitter, Output } from '@angular/core';
import { EmrButtonComponent, EmrModalComponent } from 'emr-ng-shared';
import { BsModalRef } from 'ngx-bootstrap/modal';

export class SensorChartResponseOkEventArgs {
  modalRef: BsModalRef;
}

@Component({
  selector: 'app-sensor-chart-response',
  templateUrl: './sensor-chart-response.component.html',
  styleUrls: ['./sensor-chart-response.component.css'],
  standalone: true,
  imports: [EmrModalComponent, EmrButtonComponent]
})
export class SensorChartResponseComponent {

  @Output() ok = new EventEmitter<SensorChartResponseOkEventArgs>();

    errorMessage: string = null;

    constructor(public bsModalRef: BsModalRef) {}

    onOkClick() {
      const args = new SensorChartResponseOkEventArgs();
      args.modalRef = this.bsModalRef;
      this.ok.emit(args);
      this.bsModalRef.hide();
    }

}
